import { DriverComponent } from './driver/driver.component';
import { DriverChildRoutes } from './driver/driver.routing';
import { AuthGuard } from '@/auth/guard/auth.guard';
import { RouteWithGuardData } from '@/auth/interface/auth.interface';
import { getDefinitionByPath } from '@/auth/routes/auth.routes';
import { ResultActionsComponent } from './driver/result/result-actions/result-actions.component';

export const SearchChildRoutes: RouteWithGuardData[] = [
  {
    path: 'driver',
    component: DriverComponent,
    children: DriverChildRoutes,

    canActivate: [AuthGuard],
    data: getDefinitionByPath('/search/driver'),
  },
  {
    path: 'infraction',
    component: DriverComponent,
    children: DriverChildRoutes,

    canActivate: [AuthGuard],
    data: getDefinitionByPath('/search/infraction'),
  },
  {
    path: 'action/result/:ofuscatedData',
    component: ResultActionsComponent,
    data: getDefinitionByPath('/search/requests'),
  },
  {
    path: '',
    pathMatch: 'prefix',
    redirectTo: '/search/driver',
  },
];
